module.exports = __webpack_public_path__ + "img/fx.89864f2e.png";